export default "__VITE_ASSET__BfiN76tV__";